import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingCorporation: false,
  isLoadingCustomers: false,
  corporations: [],
  customers: [],
  selectedCorporation: null,
  selectedCustomers: [],
  page: 1,
  totalPages: 0,
  corporationError: null,
};

export const corporationSlice = createSlice({
  name: "corporation",
  initialState,
  reducers: {
    setSelectedCorporation: (state, { payload }) => {
      state.selectedCorporation = payload;
    },
    setSelectedCustomers: (state, { payload }) => {
      state.selectedCustomers.push(payload);
    },
    setCustomers: (state, { payload }) => {
      state.customers = payload;
    },
    setLoadingCustomers: (state, { payload }) => {
      state.isLoadingCustomers = payload;
    },
    setLoadingCorporation: (state, { payload }) => {
      state.isLoadingCorporation = payload;
    },
    loadCorporations: (state, action) => {
      state.corporations = action.payload.result;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
    },
    search: (state, { payload }) => {
      state.isLoadingCorporation = true;
      state.page = 1;
      state.corporations = payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setCorporationError: (state, { payload }) => {
      state.corporationError = payload;
    },
    clearSelectedCustomers: (state) => {
      state.selectedCustomers = [];
    },
    clearCorporations: (state) => {
      state.corporations = [];
    },
    clearSelectedCorporation: (state) => {
      state.selectedCorporation = null;
    },
    removeSelectedCustomer: (state, { payload }) => {
      state.selectedCustomers = state.selectedCustomers.filter(
        (customer) => customer.id !== payload
      );
    },
  },
});
export const corporationActions = corporationSlice.actions;

export default corporationSlice.reducer;
